export { default as Element } from './shapes/element';
export { default as Circle } from './shapes/circle';
export { default as Arc } from './shapes/arc';
export { default as Path } from './shapes/path';
export { default as MultiPath } from './shapes/multi-path';
export { default as Text } from './shapes/text';
export { default as Image } from './shapes/image';
export { default as Group } from './shapes/group';
export { default as Layout } from './shapes/layout';
export { default as Rect } from './shapes/rect';


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/shapes.js
// module id = ../../../../@progress/kendo-drawing/dist/es/shapes.js
// module chunks = vendor